var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    { staticClass: "plan-card" },
    [
      _vm.plan || _vm.subscription || _vm.isBacker
        ? _c(
            "div",
            {
              class: [
                `plan-card card position-relative ${_vm.colorSet.cardColor}`,
                { "with-top-tag": _vm.isCurrentPlan },
              ],
              staticStyle: {
                "--link-color": "var(--fa-navy)",
                "--card-color": "var(--fa-navy)",
              },
            },
            [
              _c("plan-info", {
                attrs: {
                  plan: _vm.plan,
                  subscription: _vm.subscription,
                  determinations: _vm.determinations,
                  price: _vm.price,
                  "price-with-discount": _vm.priceWithDiscount,
                  discount: _vm.discount,
                  "is-current-plan": _vm.isCurrentPlan,
                  "color-set": _vm.colorSet,
                  "is-upgrading": _vm.isUpgrading,
                  seats: _vm.seats,
                  "has-limited-offer-badge": _vm.hasLimitedOfferBadge,
                  "plan-icon-style": _vm.planIconStyle,
                  "account-view": _vm.accountView,
                },
              }),
              _vm._v(" "),
              _vm.isCurrentPlan
                ? _c("current-plan-badge", {
                    attrs: {
                      plan: _vm.plan,
                      subscription: _vm.subscription,
                      determinations: _vm.determinations,
                      "color-set": _vm.colorSet,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.allowPlanActions
                ? _c("plan-action", {
                    attrs: { determinations: _vm.determinations },
                    on: {
                      "setup-auto-renew": function ($event) {
                        return _vm.$emit("setup-auto-renew")
                      },
                      "add-payment-method": function ($event) {
                        return _vm.$emit("add-payment-method")
                      },
                      "update-payment-method": function ($event) {
                        return _vm.$emit("update-payment-method")
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("features", {
                attrs: {
                  plan: _vm.plan,
                  subscription: _vm.subscription,
                  determinations: _vm.determinations,
                  seats: _vm.seats,
                  "color-set": _vm.colorSet,
                },
              }),
              _vm._v(" "),
              _c("services", {
                attrs: {
                  determinations: _vm.determinations,
                  "color-set": _vm.colorSet,
                  plan: _vm.plan,
                },
              }),
              _vm._v(" "),
              _vm.isShowingSubscriptionDetails && _vm.subscription
                ? _c("subscription-details", {
                    attrs: { subscription: _vm.subscription },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("additional-warnings", {
        attrs: {
          subscription: _vm.subscription,
          determinations: _vm.determinations,
          "color-set": _vm.colorSet,
        },
      }),
      _vm._v(" "),
      _c("card-footer", {
        attrs: {
          plan: _vm.plan,
          subscription: _vm.subscription,
          discount: _vm.discount,
          "price-with-discount": _vm.priceWithDiscount,
          "pre-order-backer-dates": _vm.preOrderBackerDates,
          determinations: _vm.determinations,
          "allow-plan-actions": _vm.allowPlanActions,
          "allow-plan-change": _vm.allowPlanChange,
          "color-set": _vm.colorSet,
        },
        on: {
          "setup-auto-renew": function ($event) {
            return _vm.$emit("setup-auto-renew")
          },
          cancel: function ($event) {
            return _vm.$emit("cancel")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }